<template>
    <div class="container">
        <div class="row h-100 register">
            <div class="col-8 mx-auto  p-5 bg-white shadow-sm">
                <h2 class="h2 text-center pb-3">
                    Reset your password
                </h2>
                <hr class="w-25">
                
                <slide-y-up-transition>
                    <div class="row" v-if="sent">
                        <div class="col-8 mx-auto ">
                            <div class="alert alert-success text-center">
                                E-email has been sent to you address.<br/>
                                Please follow the included link to reset your password
                            </div>
                        </div>
                    </div>
                </slide-y-up-transition>
                
                <slide-y-up-transition>
                    <div class="row" v-if="!sent">
                        <div class="col-8 mx-auto ">
                            <p class="text-center">
                                Enter your user account's verified email address and we will send you a password reset
                                link.
                            </p>
                            <div class="form">
                                <div class="form-group">
                                    <input v-model="email"
                                           :class="{'is-invalid' : $v.email.$error || errors.email.length}"
                                           type="email" class="form-control" placeholder="Email address">
                                    <div class="invalid-feedback" v-if="!$v.email.required">Please enter your
                                        email!
                                    </div>
                                    <div class="invalid-feedback" v-if="!$v.email.email">Please enter valid
                                        email!
                                    </div>
                                    <div class="invalid-feedback" v-for="(err, key) in errors.email" :key="key">{{
                                            err
                                        }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button type="button" @click="requestReset"
                                            class="btn btn-success btn-block btn-success-gradient">
                                        Send password reset email
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </slide-y-up-transition>
            </div>
        </div>
    </div>
</template>

<script>
import {SlideYUpTransition} from 'vue2-transitions'
import {validationMixin} from 'vuelidate';
import {email, required} from "vuelidate/lib/validators";
import api from "@/utils/api";

export default {
    name: "PasswordReset",
    components: {SlideYUpTransition},
    mixins: [validationMixin],
    data() {
        return {
            sent: false,
            email: null,
            errors: {
                email: [],
            }
        }
    },
    validations: {
        email: {
            required, email
        },
    },
    methods: {
        requestReset: function () {
            this.errors = {
                email: [],
            }
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            let that = this;
            api.passwordReset(this.email).then(() => {
                this.sent = true
            }).catch(error => {
                if (error.response.status === 400 && error.response.data.error.code === 11111) {
                    that.errors = error.response.data.meta
                }
            })
        }
    },
}
</script>

<style scoped>

</style>
